import {CharacterInfo} from "../assets/constants/characterInfo";

export const CHARACTER_STORAGE_KEY = "character";

export const getCharacterFromStorage = (): CharacterInfo | null => {
  try {
    const stored = localStorage.getItem(CHARACTER_STORAGE_KEY);
    if (!stored) {
      return null;
    }
    return JSON.parse(stored) as CharacterInfo;
  } catch {
    return null;
  }
};

export const saveCharacterToStorage = (character: CharacterInfo): void => {
  localStorage.setItem(CHARACTER_STORAGE_KEY, JSON.stringify(character));
};
